// Keep in sync with db_client config.py TIMEFRAMES_GROUPS (scanner group timeframes).
export const LOGS_VIEWER_TIMEFRAMES = [
  'ZERO', '15s', '30s', '45s',
  '1m', '2m', '3m', '4m', '6m', '8m', '12m', '16m', '23m', '32m', '45m', '64m', '90m',
  '2h', '3h', '4h', '6h', '8h', '12h', '16h', '1d', '2d', '3d', '4d', '8d', '12d', '16d'
];
